function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll("[id^=\"Details-\"] summary").forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN"
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"" + "pauseVideo" + "\",\"args\":\"\"}", "*");
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage("{\"method\":\"pause\"}", "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function(selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];

    if (value === option.value || value === option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};

  const method = options["method"] || "post";
  const params = options["parameters"] || {};
  const form = document.createElement("form");

  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (let key in params) {
    const hiddenField = document.createElement("input");

    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);

    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    const value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    const value = this.provinceEl.getAttribute("data-default");

    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    let opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute("data-provinces");
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length === 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (let i = 0; i < provinces.length; i++) {
        let opt = document.createElement("option");

        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];

        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    const close = this.querySelector(".menu-drawer__close");

    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );

    this.querySelectorAll("button:not(.localization-selector)").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );

    if (close) close.addEventListener("click", event => this.closeMenuDrawer(event, this));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
      summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
      submenu.classList.remove("submenu-open");
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;

    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );

    this.header.classList.add("menu-open");

    setTimeout(() => this.mainDetailsToggle.classList.add("menu-opening"));

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector("[id^=\"ModalClose-\"]").addEventListener("click", this.hide.bind(this, false));
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model")) this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector("[role=\"dialog\"]"));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}

customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector("[id^=\"Deferred-Poster-\"]");
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", "true");
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName === "VIDEO" && deferredElement.getAttribute("autoplay")) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("[id^=\"Slider-\"]");
    this.sliderItems = this.querySelectorAll("[id^=\"Slide-\"]");
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.tabulatedCarousel = this.closest(".tabulated-carousel");
    this.prevButton = this.querySelector("button[name=\"previous\"]");
    this.nextButton = this.querySelector("button[name=\"next\"]");
    this.continuous = this.slider.getAttribute("data-continuous");
    this.isTouch = window.matchMedia("(max-width: 989px)").matches;
    this.isMobile = window.matchMedia("(max-width: 750px)").matches;
    this.delay = 500;

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    this.resizeObserver();

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  resizeObserver() {
    const resizeObserver = new ResizeObserver(() => {
      this.initPages();
      this.isTouch = window.matchMedia("(max-width: 989px)").matches;
    });

    resizeObserver.observe(this.slider);
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);

    if (this.sliderItemsToShow.length < 2) return;

    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.ceil(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );

    if (this.continuous) this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage;
    else this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll("[id^=\"Slide-\"]");
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage !== previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.sliderItems.length <= this.slidesPerPage) {
      this.prevButton.classList.add("hidden");
      this.nextButton.classList.add("hidden");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();

    if (this.tabulatedCarousel) this.slider.style.scrollBehavior = "smooth";

    const step = event.currentTarget.dataset.step || 1;

    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;

    if (!this.continuous) this.sliderItems[this.currentPage - 1].style.opacity = "0";

    if (this.continuous) this.slider.scrollTo({ left: this.slideScrollPosition });
    else setTimeout(() => this.slider.scrollTo({ left: this.slideScrollPosition, behavior: "instant" }), this.delay);
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();

    this.sliderControlWrapper = this.querySelector(".slider-buttons");

    if (!this.sliderControlWrapper) return;

    this.enableSliderLooping = true;
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
    this.autoplayEnabled = this.slider.getAttribute("data-autoplay") === "true";
    this.zoomEnabled = this.slider.getAttribute("data-zoom") === "true";
    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    this.index = this.slider.dataset.index;
    this.paused = true;
    this.mousePressed = false;

    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.addEventListeners();
    this.setupTabAutoPlay();

    if (this.continuous) this.addInfiniteSlide();

    if (this.autoplayEnabled) this.setAutoPlay();
    if (this.slider.querySelector(".slideshow__video")) this.addVideoControlListeners();
    if (this.zoomEnabled) this.addZoomListeners();

    subscribe(PUB_SUB_EVENTS.sliderUpdate, event => {
      if (this.zoomEnabled) this.goToSlide(event);
    });

    subscribe(PUB_SUB_EVENTS.sliderInit, event => this.updateSlider(event));
  }

  addEventListeners() {
    this.sliderControlLinksArray.forEach(link => this.addLinksEvents(link));
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.addEventListener("mousedown", this.activateSlideByGrab);
    this.addEventListener("mouseleave", this.stopSlideGrab);
    this.addEventListener("mouseup", this.stopSlideGrab);
    this.addEventListener("mousemove", event => debounce(this.moveSliderByGrab(event), 200));
    this.addEventListener("touchstart", this.activateSlideByGrab);
    this.addEventListener("touchend", this.stopSlideGrab);
    this.addEventListener("touchmove", event => debounce(this.moveSliderByGrab(event), 200));

    this.setSlideVisibility();
  }

  addLinksEvents(link) {
    link.addEventListener("click", this.linkToSlide.bind(this));
    link.addEventListener("touchstart", this.linkToSlide.bind(this));
  }

  setupTabAutoPlay() {
    const tabs = this.closest("content-tabs");

    if (tabs) {
      const tab = tabs.querySelector(`.tabs [data-index="${this.index}"]`);

      if (this.index === "1") this.paused = false;
      if (tab && this.index === tab.dataset.index) tab.addEventListener("click", () => this.play());
    }
  }

  addInfiniteSlide() {
    if (this.sliderItems.length && this.sliderItems.length > this.slidesPerPage) {
      this.resetPages();

      for (let i = 0; i < this.slidesPerPage; i++) {
        const itemClone = this.sliderItems[i].cloneNode(true);
        this.slider.appendChild(itemClone);
      }

      for (let i = this.sliderItemsToShow.length - 1; i >= this.sliderItemsToShow.length - this.slidesPerPage; i--) {
        const itemClone = this.sliderItems[i].cloneNode(true);
        this.slider.prepend(itemClone);
      }

      this.sliderItems = this.querySelectorAll("[id^=\"Slide-\"]");
      this.slider.scrollTo({ left: this.sliderItemOffset * this.slidesPerPage, behavior: "instant" });
    }
  }

  goToSlide(event) {
    setTimeout(() => this.slider.scrollTo({
      left: this.sliderItemOffset * (event.slide - 1),
      behavior: "instant"
    }), this.delay);
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", debounce(this.focusInHandling.bind(this)), 200);
    this.addEventListener("touchstart", this.focusInHandling.bind(this));
    this.addEventListener("touchend", this.focusOutHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.continuous && this.index === "1") this.play();
    else this.play();
  }

  onButtonClick(event) {
    super.onButtonClick(event);

    this.slideBoundaryTransitions(event.currentTarget.name);
  }

  slideBoundaryTransitions(direction) {
    this.isFirstSlide = this.currentPage === (this.tabulatedCarousel ? 2 : 1);
    this.isLastSlide = this.currentPage === this.totalPages;
    this.offset = this.slider.scrollLeft % this.clientWidth;

    if (!this.isFirstSlide && !this.isLastSlide) return;

    if (this.isFirstSlide && direction === "previous") {
      this.slideScrollPosition = this.continuous
        ? this.sliderItemOffset * (this.sliderItemsToShow.length - this.slidesPerPage * 2) + this.offset
        : this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;

      // Delay to allow animation to finish before resetting the slider.
      if (!this.continuous) this.sliderItems[this.currentPage - 1].style.opacity = "0";

      setTimeout(() => this.slider.scrollTo({ left: this.slideScrollPosition, behavior: "instant" }), this.delay);
    }

    if (this.isLastSlide && direction === "next") {
      this.continousReposition = this.isMobile
        ? (this.sliderItemOffset * this.slidesPerPage * 1.45)
        : (this.sliderItemOffset * this.slidesPerPage) - this.offset;

      this.slideScrollPosition = this.continuous ? this.continousReposition : 0;

      if (!this.continuous) this.sliderItems[this.currentPage - 1].style.opacity = "0";

      setTimeout(() => this.slider.scrollTo({ left: this.slideScrollPosition, behavior: "instant" }), this.delay);
    }

    if (this.continuous) {
      setTimeout(() => this.slider.scrollTo({ left: this.slideScrollPosition, behavior: "instant" }), this.delay);
    }
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");
    this.activeMedia = this.sliderItems[this.currentPage - 1];
    this.colourScheme = this.activeMedia?.dataset.colour;

    if (!this.sliderControlButtons.length) return;

    if (!this.continuous) {
      this.sliderControlButtons.forEach((link) => {
        link.classList.remove("slider-counter__link--active");
        link.removeAttribute("aria-current");

        if (this.colourScheme) {
          link.classList.add(`slider-counter__link--${this.colourScheme}`);
          link.classList.remove(`slider-counter__link--${this.colourScheme === "light" ? "dark" : "light"}`);
        }
      });

      if (this.colourScheme) this.updateButtonsColourScheme();

      this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
      this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true);
      if (this.zoomEnabled) this.resetZoom();
    }
  }

  updateButtonsColourScheme() {
    this.prevButton.classList.add(`slider-button--${this.colourScheme}`);
    this.nextButton.classList.add(`slider-button--${this.colourScheme}`);
    this.prevButton.classList.remove(`slider-button--${this.colourScheme === "light" ? "dark" : "light"}`);
    this.nextButton.classList.remove(`slider-button--${this.colourScheme === "light" ? "dark" : "light"}`);
  }

  focusOutHandling() {
    if (this.autoplayEnabled) {
      if (this.continuous && this.paused) this.play();
      else if (this.slider.getAttribute("aria-live") === "polite") this.play();
    }
  }

  focusInHandling() {
    if (this.autoplayEnabled) {
      if (this.continuous && !this.paused) this.pause();
      else if (this.slider.getAttribute("aria-live") === "off") this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    this.paused = false;

    if (this.continuous) {
      this.continuousPlay();
    } else {
      clearInterval(this.autoplay);

      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }
  }

  continuousPlay() {
    this.startTime = this.getTime();
    this.scrollToX = this.slider.scrollWidth - this.slider.clientWidth;
    this.scrollFromX = this.slider.scrollLeft;
    this.duration = (this.scrollToX - this.scrollFromX) / 0.1;

    this.continuousScroll();
  }

  continuousScroll() {
    if (this.paused) return;

    this.slider.style.scrollBehavior = "auto";

    const currentTime = this.getTime() - this.startTime;
    const scrollPercentage = Math.min(1, currentTime / this.duration);
    const scrollX = Math.ceil(scrollPercentage * (this.scrollToX - this.scrollFromX) + this.scrollFromX);

    this.slider.scrollTo({ left: scrollX });

    if (this.scrollToX === scrollX) {
      this.modifier = this.isMobile ? 1.45 : 1;
      this.slider.scrollTo({ left: (this.sliderItemOffset * (this.slidesPerPage * this.modifier)) });

      return setTimeout(() => this.play());
    }

    requestAnimationFrame(this.continuousScroll.bind(this));
  }

  getTime() {
    return "now" in window.performance ? performance.now() : new Date().getTime();
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");

    if (this.continuous) {
      this.slider.style.scrollBehavior = "smooth";
      this.paused = true;
    }

    clearInterval(this.autoplay);
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.totalPages
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;

    if (!this.tabulatedCarousel) this.sliderItems[this.currentPage - 1].style.opacity = "0";

    setTimeout(() => this.slider.scrollTo({ left: slideScrollPosition, behavior: "instant" }), this.delay);
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");

      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach((button) => button.removeAttribute("tabindex"));
        if (!this.continuous) item.style.opacity = "1";

        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length) linkElements.forEach((button) => button.setAttribute("tabindex", "-1"));
        if (!this.continuous) item.style.opacity = "0";

        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();

    const targetPage = this.sliderControlLinksArray.indexOf(event.currentTarget);
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (targetPage + 1 - this.currentPage);

    if (!this.tabulatedCarousel && targetPage + 1 !== this.currentPage) {
      this.sliderItems[this.currentPage - 1].style.opacity = "0";
    }

    setTimeout(() => this.slider.scrollTo({ left: slideScrollPosition, behavior: "instant" }), this.delay);
  }

  activateSlideByGrab(event) {
    if (!this.isTouch) event.preventDefault();

    if (this.prevButton.contains(event.target) || this.nextButton.contains(event.target)) return;
    if (this.tabulatedCarousel) this.slider.style.scrollBehavior = "auto";

    const pageX = event.pageX !== undefined ? event.pageX : event.targetTouches[0].pageX;
    const pageY = event.pageY !== undefined ? event.pageY : event.targetTouches[0].pageY;

    this.mousePressed = true;
    this.slider.style.cursor = "grabbing";
    this.scrollOffset = this.slider.scrollLeft;
    this.startX = pageX - this.slider.offsetLeft;
    this.startY = pageY;
  }

  moveSliderByGrab(event) {
    if (!this.isTouch) event.preventDefault();

    if (!this.mousePressed) return;

    this.setLinkAction("none");
    this.dragging = true;

    const threshold = 50;
    const pageX = event.pageX !== undefined ? event.pageX : event.targetTouches[0].pageX;
    const pageY = event.pageY !== undefined ? event.pageY : event.targetTouches[0].pageY;
    const positionX = pageX - this.slider.offsetLeft;
    const positionY = pageY;
    const scrollDistanceX = positionX - this.startX;
    const scrollDistanceY = positionY - this.startY;
    const direction = pageX > this.startX ? "previous" : "next";
    const isVerticalMovement = Math.abs(scrollDistanceY) > Math.abs(scrollDistanceX);
    const noMovement = Math.abs(scrollDistanceY) < threshold && Math.abs(scrollDistanceX) < threshold;

    if (isVerticalMovement || noMovement) return;
    if (this.tabulatedCarousel) this.slider.scrollLeft = this.scrollOffset - scrollDistanceX;
    else {
      if (Math.abs(scrollDistanceX) < this.clientWidth / 4) return;

      this.sliderItems[this.currentPage - 1].style.opacity = "0";

      setTimeout(() => this.slider.scrollTo({
        left: this.scrollOffset - (scrollDistanceX * 2),
        behaviour: "instant"
      }), this.delay);
    }

    this.slideBoundaryTransitions(direction);
  }

  stopSlideGrab(event) {
    if (!this.isTouch) event.preventDefault();

    if (this.prevButton.contains(event.target) || this.nextButton.contains(event.target)) return;

    this.mousePressed = false;
    this.setLinkAction("auto");
    this.style.cursor = "auto";
    this.dragging = false;
  }

  setLinkAction(pointer) {
    this.sliderItems.forEach(slide => {
      const links = slide.querySelectorAll("a");

      links.forEach(link => link.style.pointerEvents = pointer);
    });
  }

  addZoomListeners() {
    this.TRANSLATE_PARAMS = "translate(-50%, -50%)";
    this.modal = this.slider.closest("modal-component");
    this.zoomOut = this.modal.querySelector(".modal__zoom--out");
    this.zoomButtons = [this.zoomOut, this.modal.querySelector(".modal__zoom--in")];
    this.zoomStep = 0;
    this.zoomEvent();
  }

  zoomEvent() {
    this.zoomButtons.forEach(button => {
      if (button) button.addEventListener("click", () => this.zoomMedia(button));
    });
  }

  zoomMedia(button) {
    const isZoomIn = button.classList.contains("modal__zoom--in");
    const threshold = isZoomIn ? 5 : 0;

    if (this.zoomStep === threshold) return button.classList.add("modal__zoom--disabled");

    this.zoomButtons.forEach(button => button.classList.remove("modal__zoom--disabled"));

    isZoomIn ? this.zoomStep++ : this.zoomStep--;

    this.zoomTransform();
  }

  zoomTransform() {
    const media = this.activeMedia.querySelector(".figure__image");
    const scale = 1 + this.zoomStep * 0.1;

    media.style.transform = `${this.TRANSLATE_PARAMS} scale(${scale})`;
  }

  resetZoom() {
    this.zoomStep = 0;
    this.zoomTransform();
    this.zoomOut.classList.add("modal__zoom--disabled");
  }

  updateSlider(event) {
    if (event && this.slider.id !== event.slider) return;

    this.resetPages();
    this.addInfiniteSlide();
  }
}


customElements.define("slideshow-component", SlideshowComponent);

class AnnouncementSlider extends SlideshowComponent {
  constructor() {
    super();

    this.addCloseButtonEventListener();
    this.addLoopBehaviour();
  }

  addEventListeners() {
    this.sliderControlLinksArray.forEach(link => this.addLinksEvents(link));
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));

    this.setSlideVisibility();
  }

  onButtonClick(event) {
    event.preventDefault();

    const step = event.currentTarget.dataset.step || 1;

    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollTop + step * this.sliderItemOffset
        : this.slider.scrollTop - step * this.sliderItemOffset;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollTop + this.sliderFirstItemNode.clientHeight * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.slider.scrollTo({ top: this.slideScrollPosition });
  }

  initPages() {
    super.initPages();

    this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollTop === 0) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  addLoopBehaviour() {
    let oldValue = 0;

    this.slider.addEventListener("scroll", () => {
      const sliderHeight = this.slider.clientHeight;

      if (this.slider.scrollTop === sliderHeight && oldValue !== sliderHeight) {
        this.slider.append(this.slider.firstElementChild);
        this.slider.scrollTo({ top: 0, behavior: "instant" });

        oldValue = sliderHeight;
      } else {
        oldValue = 0;
      }
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");

      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach((button) => button.removeAttribute("tabindex"));

        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length) linkElements.forEach((button) => button.setAttribute("tabindex", "-1"));

        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset;
    return element.offsetTop + element.clientHeight <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
  }

  autoRotateSlides() {
    const isLastSlide = this.currentPage === this.sliderItems.length;
    const slideOffset = this.slider.scrollTop + this.slider.querySelector(".slideshow__slide").clientHeight;
    const slideScrollPosition = isLastSlide ? 0 : slideOffset;

    this.slider.scrollTo({ top: slideScrollPosition });
  }

  addCloseButtonEventListener() {
    const buttonClose = document.querySelector(".utility-bar__close");
    const announcementBar = document.querySelector(".announcement-bar-section");

    buttonClose.addEventListener("click", () => announcementBar.classList.add("visually-hidden"));
  }
}

customElements.define("announcement-slider", AnnouncementSlider);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.addAccordionListener();
  }

  onVariantChange(event) {
    if (event.target.value === "") return;

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;

    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}`);

    productForms.forEach((productForm) => {
      const input = productForm.querySelector("input[name=\"id\"]");

      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );

    const inputWrappers = [...this.querySelectorAll(".product-form__input")];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll("input[type=\"radio\"], option")];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);

      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace("[value]", input.getAttribute("value"));
      }
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const specification = html.querySelector(".product__specification .accordion__content");
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        this.updateSpecification(specification);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);

        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.style.display === "none" : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant
          }
        });
      });
  }

  updateSpecification(content) {
    const specification = document.querySelector(".product__specification .accordion__content");

    specification.innerHTML = content.innerHTML;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector("[name=\"add\"]");
    const addButtonText = productForm.querySelector("[name=\"add\"] > span");
    if (!addButton) return;

    if (disable) {
      addButton.style.display = "none";
      if (text) addButtonText.textContent = text;
    } else {
      addButton.style.display = "flex";
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector("[name=\"add\"]");
    const addButtonText = button.querySelector("[name=\"add\"] > span");
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent);
    return this.variantData;
  }

  addAccordionListener() {
    const options = this.querySelectorAll("accordion-wrapper li");

    options.forEach(option => {
      option.addEventListener("click", () => {
        const input = option.closest(".product-form__input");
        const select = input.querySelector("select");
        const selectOptions = select.querySelectorAll("option");

        options.forEach(option => option.classList.remove("selected"));

        selectOptions.forEach(selectOption => {
          if (selectOption.value === option.dataset.value) {
            select.value = option.dataset.value;

            option.classList.add("selected");

            this.dispatchEvent(new Event("change"));
          }
        });
      });
    });
  }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => this.renderContent(text))
        .catch(e => console.error(e));
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
  }

  renderContent(content) {
    const html = document.createElement("div");

    html.innerHTML = content;

    this.recommendations = html.querySelector(".recommendations__list");
    this.innerHTML = this.recommendations.outerHTML;

    if (!this.querySelector("slideshow-component") && this.classList.contains("complementary-products")) {
      this.remove();
    }

    if (html.querySelector(".grid__item")) this.classList.add("product-recommendations--loaded");
  }
}

customElements.define("product-recommendations", ProductRecommendations);


// Footer Form Animation
const initFooterListener = () => {
  const input = document.querySelector(".footer__newsletter .field-group .field__input");
  const form = document.querySelector(".footer__form");

  if (input) input.addEventListener("mousedown", () => form.classList.add("footer__form--active"));
};

// Record the collection when on a collection page
const setCollectionTag = () => {
  const url = window.location.href;

  if (url.includes("collection") && !url.includes("all")) {
    const collection = document.querySelector(".product-grid-container");

    if (collection) {
      const url = collection.dataset.url;
      const tag = collection.dataset.name;

      window.sessionStorage.setItem("collectionTag", JSON.stringify({ url, tag }));
    }
  }
};

initFooterListener();
setCollectionTag();
